import { useSelector } from "react-redux";
import { Types } from "Types";
import { Selectors as AdministrateurBienActionSelectors } from "../../../redux/AdministrateurDeBien";
import { Selectors as BienSelectors } from "../../../redux/Bien";
import { Selectors as DossierLocationSelectors } from "../../../redux/DossierLocation";
import { Selectors as UtilisateursActionSelectors } from "../../../redux/Utilisateurs";
import { Selectors as DossierLocationSelector } from "../../../redux/DossierLocation";

export const useDataBien = () => {
  const utilisateurConnecte = useSelector((state: Types.RootState) =>
    UtilisateursActionSelectors.getUtilisateurConnecte(state)
  );
  const adbDetail = useSelector((state: Types.RootState) =>
    AdministrateurBienActionSelectors.getADBDetail(state)
  );
  const adbId = useSelector((state: Types.RootState) =>
    AdministrateurBienActionSelectors.getAdbId(state)
  );
  const selectedSite = useSelector((state: Types.RootState) =>
    AdministrateurBienActionSelectors.getSelectedSite(state)
  );

  const modifBienData = useSelector((state: Types.RootState) =>
    DossierLocationSelectors.getBienData(state)
  );
  const bienDataFormEnCours = useSelector((state: Types.RootState) =>
    BienSelectors.getBien(state)
  );

  const oldDossierLocation = useSelector((state: Types.RootState) =>
    DossierLocationSelector.getDossierLocation(state)
  );

  return {
    utilisateurConnecte,
    adbDetail,
    adbId,
    selectedSite,
    oldDossierLocation,
    modifBienData,
    bienDataFormEnCours,
  };
};
